import { Flexbox, Form } from '@/components'
import React from 'react'
import PropTypes from 'prop-types'

function Email({
  currentPerson,
  newEmail,
  values,
  errors,
  touched,
  setFieldValue,
}) {
  return (
    <div className="p-2 text-center">
      <div className="mb-2 pb-2">
        <div className="h6 mb-2">
          <i className="fas fa-exclamation-triangle pr-2" />
          Atenção!
        </div>
        Após alterar o e-mail será necessária uma nova verificação de conta.
        <div>
          Seu e-mail atual é:{' '}
          <b>{newEmail || currentPerson?.email}</b>
        </div>
      </div>
      <Flexbox.Columns className="flex-centered">
        <Flexbox.Column className="col-3 col-sm-12">
          <Form.Group>
            <Form.Label htmlFor="email">
              Digite o novo e-mail que deseja utilizar:
            </Form.Label>
            <Form.ValidationField name="email">
              {({ field }) => (
                <Form.Input
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...field}
                  id="email"
                  placeholder="novo@email.com"
                  autoComplete="off"
                  value={values.email}
                  onChange={(e) => setFieldValue('email', e.target.value)}
                />
              )}
            </Form.ValidationField>
            {touched?.email && errors?.email && (
              <Form.Hint className="text-error">{errors.email}</Form.Hint>
            )}
          </Form.Group>
        </Flexbox.Column>
      </Flexbox.Columns>
    </div>
  )
}

Email.propTypes = {
  currentPerson: PropTypes.objectOf(PropTypes.any),
  newEmail: PropTypes.string,
  values: PropTypes.objectOf(PropTypes.any).isRequired,
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
  touched: PropTypes.objectOf(PropTypes.any).isRequired,
  setFieldValue: PropTypes.func.isRequired,
}

Email.defaultProps = {
  currentPerson: null,
  newEmail: null,
}

export default Email
